import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  connect() {
    this.element.style.cursor = "pointer"
  }

  navigate(event) {
    // クリックしたセルがリンクを含んでいる場合はスキップ
    if (event.target.closest('a') || event.target.closest('button')) {
      return
    }

    const row = event.currentTarget
    const url = row.dataset.url
    
    if (url) {
      // Turboを使用してページ遷移
      window.location.href = url
    }
  }
}